<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  // created() {
  //   this.getScreen();
  // },
  mounted(){
    this.setMobile();
  },
  methods: {
    getScreen() {
      let clientWidth = document.documentElement.clientWidth;
      this.$store.commit("SET_SCREENWIDTH", clientWidth);
        
    },
    setMobile() {
      //监听屏幕
      addEventListener("resize", () => {
        this.getScreen();
      });
    }
  }
};
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
